var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17.0155V19.0155C0.5 20.1201 1.39543 21.0155 2.5 21.0155H22.5C23.6046 21.0155 24.5 20.1201 24.5 19.0155V17.0155H17.5C17.5 17.5678 17.0523 18.0155 16.5 18.0155H8.5C7.94771 18.0155 7.5 17.5678 7.5 17.0155H0.5Z",
    fill: "#F49607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17.0155V19.0155C0.5 20.1201 1.39543 21.0155 2.5 21.0155H22.5C23.6046 21.0155 24.5 20.1201 24.5 19.0155V17.0155H17.5C17.5 17.5678 17.0523 18.0155 16.5 18.0155H8.5C7.94771 18.0155 7.5 17.5678 7.5 17.0155H0.5Z",
    fill: "#F49607"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.01546C4.94772 4.01546 4.5 4.46318 4.5 5.01546V15.0155H2.5V5.01546C2.5 3.35861 3.84315 2.01546 5.5 2.01546H13.5V4.01546H5.5Z",
    fill: "#F49607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 9.10136L14.4999 6.10134L13.0857 7.51555L18.4999 12.9298L23.9141 7.51555L22.4999 6.10134L19.4999 9.10132V2.01546H17.4999V9.10136Z",
    fill: "#F49607"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.0154572)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayDownload);
export default __webpack_public_path__ + "static/media/play-download.994b9b542b26ae4d56028d5733fb75a8.svg";
export { ForwardRef as ReactComponent };